export default class OnboardingModalHelper {
  constructor(modalController) {
    this.modalController = modalController
    this.handleModalHide = this.handleModalHide.bind(this)
  }

  connect() {
    this.modalController.isOnboardingModal = true
    this.modalController.element.addEventListener(
      'hide.bs.modal',
      this.handleModalHide
    )
  }

  disconnect() {
    this.modalController.isOnboardingModal = false
    this.modalController.element.removeEventListener(
      'hide.bs.modal',
      this.handleModalHide
    )
  }

  handleModalHide(event) {
    if (this.modalController.allowModalClose) {
      this.modalController.allowModalClose = false
      return
    }

    event.preventDefault()
    this.showConfirmation()
  }

  showConfirmation() {
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      title: 'Confirmation',
      text: 'Are you sure you want to close this modal? Your onboarding process isn’t complete yet.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Keep Editing'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalController.allowModalClose = true
        this.modalController.closeModal()
      }
    })
  }
}